import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import {
  ETotSelectActions,
  PlaceScoTot,
  Add,
  PlaceScoTotQuick,
  UpdateScoTotQuick,
} from '../actions/totselect.actions';
import { mergeMap } from 'rxjs/operators';
import { CartService } from 'src/app/service/cart/cart.service';
import { TotSelect } from 'src/app/models/totselect.interface';
import { of } from 'rxjs';
import { IStateCart } from 'src/app/models/statecart.interface';

@Injectable()
export class TotselectEffects {
  
  placeSco$ = createEffect(() => this._action$.pipe(
    ofType<PlaceScoTot>(ETotSelectActions.PlaceScoTot),
    mergeMap((action) => this._cartService.placeScoTot(action.payload)),
    mergeMap((scoTot: TotSelect) => {
      return of(new Add(scoTot));
    })
  ));

  
  placeScoQuick$ = createEffect(() => this._action$.pipe(
    ofType<PlaceScoTotQuick>(ETotSelectActions.PlaceScoTotQuick),
    mergeMap((action) => this._cartService.placeScoTotQuick(action.payload)),
    mergeMap((stateCart: IStateCart) => {
      return of(new UpdateScoTotQuick(stateCart));
    })
  ));

  constructor(private _cartService: CartService, private _action$: Actions) {}
}
